/**
 * Single source of truth for Brew's positioning.
 *
 * Zero imports on purpose: this module is consumed by client components,
 * `server-only` modules (MCP handler), OG image routes, and vitest alike.
 * Change a string here, run `pnpm test:run` (tests/seo-messaging-invariants
 * enforces the invariants), and every surface follows.
 *
 * Two files intentionally do NOT import from here and carry hand-edited
 * copies instead: lib/agents/orchestrator/prompt-modules/core-head.ts and
 * lib/prompt-suggestions/autocomplete.ts (byte-stable prompt-cache
 * prefixes). Keep them in sync manually when the category noun changes.
 */
export const POSITIONING = {
  /** Category noun. Never "AI email generator", never "first X" claims. */
  category: 'AI-native ESP',
  categoryLong: 'AI-native email service provider (ESP)',
  audience: 'modern teams and their AI agents',
  /** Sitewide one-liner (siteConfig.description, markdown headings). */
  tagline: 'The AI-native ESP for modern teams and their AI agents',
  /** Absolute homepage <title>. Exactly one "Brew", no template applied. */
  homeTitle: 'Brew: AI-Native ESP for Modern Teams and AI Agents',
  /** Long form for JSON-LD, llms.txt headers, and About copy. */
  categorySentence:
    'Brew is the AI-native email service provider (ESP) for modern teams and their AI agents. Brand lives in markdown files Brew reads at generation time, so every email ships on-brand from the app, the API, or any agent over MCP.',
  /** Meta-description length (under 155 chars). */
  shortMeta:
    'Brew is the AI-native ESP for modern teams and AI agents. Define your brand in markdown, then generate and send on-brand emails.',
} as const
